<template>
    <div>



        <div v-if="formData" class="overflow-auto body-slider">
            <Tabs :tabs="tabs" :tabSelect="tabSelect" class="sm:px-4 sm:pt-4" />

            <div class="px-4" v-if="currentTab == 'infos'">

                <div class="border rounded bg-gray-100 pt-4 gap-2 items-center mb-4 relative">

                    <div class="flex items-center gap-2 absolute top-2 right-2 bg-white p-1 rounded-full px-3 text-xs">
                        <div class="rounded-full h-2 w-2" :class="formData?.roles?.color"></div>
                        {{ formData?.roles?.name }}
                    </div>

                    <div class="flex gap-2 items-center">
                        <div class="">
                            <div class="px-4">
                                <img src="/imgs/cracha.png" class="h-24 w-24 mb-2">
                            </div>
                        </div>
                        <div class="flex flex-col gap-1 text-sm">
                            <div>
                                <div class="text-xs">Nome:</div>
                                {{ formData.name }}
                            </div>
                            <div>
                                <div class="text-xs">Email:</div>
                                {{ formData.email }}
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-wrap gap-2 p-2">
                        <div class="rounded-lg overflow-hidden border w-full">

                            
                        </div>
                    </div>

                </div>

                

            </div>

            <div class="px-4" v-if="currentTab == 'personal_data'">
                <h2 class="text-sm pb-2">Informações pessoais (público):</h2>

                <div class="flex gap-6 items-start">
                    <div class="shrink-0">
                        <AvatarEditor :avatarURL="formData.avatar" :rounded="true" @fileSelected="handleImageUpload" />
                    </div>
                    <div class="w-full">
                        <InputText label="Seu nome - (obrigatório)" class="w-full" :value="formData.name"
                            :error="formErrors.name" placeholder="Nome" v-model="formData.name" />
                        <div class="text-xs"><span class="font-bold">Nota:</span> O seu nome e avatar são componentes
                            essenciais da sua identidade digital. Eles serão exibidos em todas as mensagens, comunicados
                            e interações que você realizar, representando sua presença em toda plataforma.</div>


                        <div class="w-full flex itens-center justify-center pt-4">
                            <SubmitButton v-if="currentTab == 'personal_data'" :submit="save"
                                label="Salvar informações pessoais" :loading="loading" />
                        </div>

                    </div>


                </div>


            </div>
            <div class="px-4" v-if="currentTab == 'security'">

                <h2 class="text-sm pb-2">Segurança do sistema:</h2>
                <div class="flex gap-6 items-start">
                    <div class="shrink-0">
                        <div class="p-6 border rounded-full bg-gray-100">
                            <svg class="h-[108px] w-[108px]" version="1.1" id="Layer_1"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                viewBox="0 0 512 512" xml:space="preserve" fill="#000000">
                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                <g id="SVGRepo_iconCarrier">
                                    <g transform="translate(1 1)">
                                        <g>
                                            <path style="fill:#f5f5f5;"
                                                d="M275.334,511L275.334,511c-5.207,0-8.678-4.339-8.678-8.678 c6.075-182.237-16.488-256.868-17.356-257.736c-1.736-4.339,0.868-9.546,5.207-11.281c4.339-1.736,9.546,0.868,11.281,5.207 c0.868,3.471,24.298,77.234,17.356,262.942C284.012,507.529,279.673,511,275.334,511z">
                                            </path>
                                            <path style="fill:#f5f5f5;"
                                                d="M491.415,294.051c-4.339,0-7.81-3.471-8.678-7.81c-6.075-58.142-14.753-104.136-25.166-128.434 C423.727,77.102,345.625,25.034,257.978,25.034c-28.637,0-57.275,5.207-83.308,16.488c-14.753,6.075-28.637,13.885-41.654,21.695 c-4.339,2.603-9.546,1.736-12.149-2.603c-2.603-4.339-1.736-9.546,2.603-12.149c13.885-8.678,28.637-16.488,45.125-23.431 c27.769-11.281,58.142-17.356,89.383-17.356c94.59,0,178.766,56.407,216.081,143.186c13.885,33.844,22.563,91.119,26.034,133.641 C500.961,289.712,497.489,293.183,491.415,294.051C492.283,294.051,491.415,294.051,491.415,294.051z">
                                            </path>
                                            <path style="fill:#f5f5f5;"
                                                d="M43.632,363.475c-3.471,0-6.942-2.603-8.678-6.075c-43.39-145.79,2.603-231.702,49.464-277.695 c3.471-3.471,8.678-3.471,12.149,0s3.471,8.678,0,12.149C34.086,152.6,18.466,242.851,51.442,352.193 c1.736,4.339-0.868,9.546-6.075,10.414C45.367,363.475,44.5,363.475,43.632,363.475z">
                                            </path>
                                            <path style="fill:#f5f5f5;"
                                                d="M100.906,450.254c-5.207,0-8.678-3.471-8.678-8.678c0-61.614,0-101.532-3.471-122.359 c-1.736-9.546-4.339-19.092-6.075-27.769C57.517,202.932,102.642,109.21,187.686,73.631 c24.298-10.414,50.332-14.753,77.234-13.885c69.424,2.603,144.922,60.746,168.353,130.169 c19.092,56.407,19.092,150.129,17.356,234.305c0,5.207-4.339,8.678-8.678,8.678c-5.207,0-8.678-4.339-8.678-8.678 c2.603-82.441,1.736-174.427-16.488-228.23c-20.827-62.481-91.119-116.285-152.732-118.888 c-24.298-0.868-47.729,3.471-69.424,13.017c-77.234,32.108-118.02,117.153-95.458,196.99c2.603,9.546,5.207,19.959,6.942,29.505 c3.471,22.563,3.471,62.481,3.471,124.963C109.584,446.783,106.113,450.254,100.906,450.254z">
                                            </path>
                                            <path style="fill:#f5f5f5;"
                                                d="M388.147,476.288L388.147,476.288c-5.207,0-8.678-4.339-8.678-8.678 c5.207-139.715,3.471-219.553-17.356-269.017c-17.356-41.654-58.142-68.556-104.136-68.556c-7.81,0-16.488,0.868-24.298,2.603 c-4.339,0.868-9.546-1.736-10.414-6.942c-0.868-4.339,1.736-9.546,6.942-10.414c9.546-1.736,18.224-2.603,27.77-2.603 c52.068,0,99.797,31.241,119.756,79.837c22.563,52.936,24.298,131.905,19.092,276.827 C396.825,472.817,392.486,476.288,388.147,476.288z M161.652,458.932c-5.207,0-8.678-3.471-8.678-8.678 c0-99.797-17.356-164.014-18.224-164.881c-15.62-58.142,3.471-118.888,48.597-150.129c4.339-2.603,9.546-1.736,12.149,1.736 c2.603,4.339,1.736,9.546-1.736,12.149c-39.051,26.902-55.539,79.837-41.654,131.037c0.868,2.603,18.224,66.82,18.224,169.22 C170.33,455.461,166.859,458.932,161.652,458.932z">
                                            </path>
                                            <path style="fill:#f5f5f5;"
                                                d="M336.079,502.322L336.079,502.322c-5.207,0-8.678-4.339-8.678-8.678c0-11.281,0-27.77,0-42.522 c0-10.414-0.868-19.959,0-26.902c0-4.339,4.339-8.678,8.678-8.678l0,0c5.207,0,8.678,4.339,8.678,8.678c0,6.075,0,15.62,0,26.034 c0,14.753,0.868,32.108,0,43.39C344.757,498.851,340.418,502.322,336.079,502.322z">
                                            </path>
                                            <path style="fill:#f5f5f5;"
                                                d="M213.72,502.322c-5.207,0-8.678-3.471-8.678-8.678c0-103.268-5.207-207.403-12.149-227.363 c-12.149-36.447,4.339-74.631,38.183-88.515c8.678-3.471,17.356-5.207,26.902-5.207c27.77,0,52.936,16.488,64.217,42.522 c17.356,40.786,22.563,112.814,23.431,165.749c0,5.207-3.471,8.678-8.678,8.678l0,0c-4.339,0-8.678-3.471-8.678-8.678 c-0.868-51.2-6.075-120.624-22.563-158.807c-7.81-19.959-26.902-32.108-47.729-32.108c-6.942,0-13.885,1.736-19.959,4.339 c-25.166,10.414-37.315,39.051-28.637,66.82c7.81,24.298,13.017,139.715,13.017,232.569 C222.398,498.851,218.927,502.322,213.72,502.322z">
                                            </path>
                                        </g>
                                        <g>
                                            <path style="fill:#B6B6B6;"
                                                d="M267.523,511L267.523,511c-5.207,0-8.678-4.339-8.678-8.678 c6.075-183.105-16.488-265.546-17.356-266.414c-1.736-4.339,1.736-9.546,6.075-10.414c4.339-1.736,9.546,1.736,10.414,6.075 c0.868,3.471,24.298,85.912,17.356,271.62C276.201,507.529,271.862,511,267.523,511z">
                                            </path>
                                            <path style="fill:#B6B6B6;"
                                                d="M483.605,285.373c-4.339,0-7.81-3.471-8.678-7.81c-3.471-33.844-11.281-95.458-25.166-128.434 C415.917,68.424,337.815,16.356,250.167,16.356c-28.637,0-57.275,5.207-83.308,16.488c-14.753,6.075-28.637,13.885-41.654,21.695 c-4.339,2.603-9.546,1.736-12.149-2.603c-2.603-4.339-1.736-9.546,2.603-12.149c13.885-8.678,28.637-16.488,45.125-23.431 C188.554,5.075,218.927-1,250.167-1c94.59,0,178.766,56.407,216.081,143.186c13.885,33.844,22.563,91.119,26.034,133.641 C492.283,281.034,488.811,284.505,483.605,285.373C484.473,285.373,483.605,285.373,483.605,285.373z">
                                            </path>
                                            <path style="fill:#B6B6B6;"
                                                d="M35.822,354.797c-3.471,0-6.942-2.603-8.678-6.075c-43.39-145.79,2.603-231.702,49.464-277.695 c3.471-3.471,8.678-3.471,12.149,0c3.471,3.471,3.471,8.678,0,12.149c-62.481,60.746-78.102,150.997-45.125,260.339 c1.736,4.339-0.868,9.546-6.075,10.414C37.557,354.797,36.689,354.797,35.822,354.797z">
                                            </path>
                                            <path style="fill:#B6B6B6;"
                                                d="M93.096,441.576c-5.207,0-8.678-3.471-8.678-8.678c0-61.614,0-101.532-3.471-122.359 c-1.736-9.546-3.471-18.224-6.075-27.77C49.706,194.254,94.832,100.532,179.876,64.953c24.298-10.414,50.332-14.753,77.234-13.885 c69.424,2.603,144.922,60.746,168.353,130.169c19.092,56.407,19.092,150.129,17.356,234.305c0,5.207-4.339,8.678-8.678,8.678 c-5.207,0-8.678-4.339-8.678-8.678c2.603-82.441,1.736-174.427-16.488-228.23c-20.827-62.481-91.119-116.285-152.732-118.888 c-24.298-0.868-47.729,3.471-69.424,13.017c-77.234,32.108-118.02,117.153-95.458,196.99c2.603,9.546,5.207,19.959,6.942,29.505 c3.471,22.563,3.471,62.481,3.471,124.963C101.774,438.105,98.303,441.576,93.096,441.576z">
                                            </path>
                                            <path style="fill:#B6B6B6;"
                                                d="M380.337,467.61L380.337,467.61c-5.207,0-8.678-4.339-8.678-8.678 c5.207-139.715,3.471-219.553-17.356-269.017c-17.356-41.654-58.142-68.556-104.136-68.556c-7.81,0-16.488,0.868-24.298,2.603 c-4.339,0.868-9.546-1.736-10.414-6.942c-0.868-4.339,1.736-9.546,6.942-10.414c9.546-1.736,18.224-2.603,27.77-2.603 c52.068,0,99.797,31.241,119.756,79.837c22.563,52.936,24.298,131.905,19.092,276.827 C389.015,464.139,384.676,467.61,380.337,467.61z M153.842,450.254c-5.207,0-8.678-3.471-8.678-8.678 c0-99.797-17.356-164.014-18.224-164.881c-15.62-58.142,3.471-118.888,48.597-150.129c4.339-2.603,9.546-1.736,12.149,1.736 c2.603,4.339,1.736,9.546-1.736,12.149c-39.051,26.902-55.539,79.837-41.654,131.037c0.868,3.471,18.224,67.688,18.224,170.088 C162.52,446.783,159.049,450.254,153.842,450.254z">
                                            </path>
                                            <path style="fill:#B6B6B6;"
                                                d="M328.269,493.644L328.269,493.644c-5.207,0-8.678-4.339-8.678-8.678c0-11.281,0-27.77,0-42.522 c0-10.414-0.868-19.959,0-26.034c0-4.339,4.339-8.678,8.678-8.678l0,0c5.207,0,8.678,4.339,8.678,8.678c0,6.075,0,15.62,0,26.034 c0,15.62,0.868,32.108,0,43.39C336.947,490.173,332.608,493.644,328.269,493.644z">
                                            </path>
                                            <path style="fill:#B6B6B6;"
                                                d="M205.91,493.644c-5.207,0-8.678-3.471-8.678-8.678c0-103.268-5.207-207.403-12.149-227.363 c-12.149-36.447,4.339-74.631,38.183-88.515c8.678-3.471,17.356-5.207,26.902-5.207c27.769,0,52.936,16.488,64.217,42.522 c17.356,40.786,22.563,112.814,23.431,165.749c0,5.207-3.471,8.678-8.678,8.678l0,0c-4.339,0-8.678-3.471-8.678-8.678 c-0.868-51.2-6.075-120.624-22.563-159.675c-7.81-19.092-26.902-32.108-47.729-32.108c-6.942,0-13.885,1.736-19.959,4.339 c-25.166,10.414-37.315,39.051-28.637,66.82c7.81,25.166,13.017,140.583,13.017,233.437 C214.588,490.173,211.117,493.644,205.91,493.644z">
                                            </path>
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                    <div class="w-full">
                        <InputText label="Nova senha de acesso" class="w-full" :value="password"
                            :error="formErrors.password" placeholder="********" v-model="password" />
                        <div class="text-xs"><span class="font-bold">Atenção:</span> Para garantir a segurança de sua
                            conta, sua senha precisa ter, pelo menos, 8 caracteres. Recomendamos que ela inclua uma
                            combinação de letras, números e símbolos especiais como _%&*# para uma maior proteção.</div>

                        <div class="w-full flex itens-center justify-center pt-4">
                            <SubmitButton :submit="savePassword" label="Alterar senha de acesso"
                                :loading="loadingPassword" />
                        </div>
                    </div>
                </div>



                <div v-if="passwordMessage" class="p-2 my-2 rounded text-xs mt-8 text-white"
                    :class="passwordError ? 'bg-rose-700' : 'bg-blue-600'">{{ passwordMessage }}</div>
            </div>
        </div>

        <div class="flex-shrink-0 px-4 py-4 flex justify-between gap-2">
            <button @click="close" type="button" class="secondaryButton gap-1">{{ $t('buttons.close') }}</button>

        </div>

    </div>
</template>

<script>
export default {
    name: 'mySettingsForm',
    props: {
        formClose: Function,
        reloadTemplate: Function,

    },
    data() {
        return {
            user: this.$SessionService.getUser(),
            imageFile: null,
            updateImage: false,
            currentTab: "infos",
            password: "",
            passwordMessage: "",
            passwordError: false,
            message: "",
            tabs: [
                { id: "1", name: "infos", current: true },
                { id: "2", name: "personal_data", current: true },
                { id: "3", name: "security", current: false },

            ],
            user: this.$SessionService.getUser(),
            loading: false,
            loadingPassword: false,
            iconImage: null,
            formErrors: {},
            formData: {
                name: "",
                email: "",
                attributs: {
                    phone: "",
                    ramal: "",
                },
            },
        }
    },
    methods: {

        handleImageUpload(image) {
            this.imageFile = image;  // Armazena o arquivo selecionado
            this.updateImage = true;  // Marca que a imagem foi atualizada
        },


        async getData() {
            await this.$ApiService.get(`/settings/users/getMySettingsUsers`).then(
                (response) => {
                    if (response.error) {
                        this.message = response.error;
                        setTimeout(() => { this.message = ""; }, 5000);
                        return;
                    }
                    this.formData = response.data;
                }
            );
        },

        async uploadImage() {
            if (this.updateImage && this.imageFile) {
                let formData = new FormData();
                formData.append('file', this.imageFile);  // Adiciona a imagem ao FormData
                formData.append('root_owners_id', this.user.root_owners_id);
                formData.append('category', 'avatars');

                try {
                    const response = await this.$http.post('upload', formData, {
                        headers: { 'Content-Type': 'multipart/form-data' },
                    });

                    return response.data.url;  // Retorna a URL da imagem enviada
                } catch (error) {
                    console.error('Erro no upload da imagem:', error);
                    this.formErrors = { image: 'Erro ao enviar a imagem.' };  // Exibe erro na imagem
                    throw new Error('Image upload failed');
                }
            }
            return null;
        },

        async save() {

            this.loading = true;

            // Primeiro, faz o upload da imagem (se houver)
            if (this.updateImage) {
                const imageUrl = await this.uploadImage();
                if (imageUrl) {
                    this.formData.avatar = imageUrl;  // Atualiza a imagem no formData
                } else {
                    this.formData.avatar = null;  // Remove imagem se não houver
                }
            }

            const formData = {
                name: this.formData.name,
                attributs: this.formData.attributs,
                avatar: this.formData.avatar,
            };


            await this.$ApiService.put(`/settings/users/updateMySettingsUsers`, formData).then(
                (response) => {
                    if (response.error) {
                        this.loading = false;
                        this.message = response.error;
                        setTimeout(() => { this.message = ""; }, 5000);
                        return;
                    }
                    this.user.name = this.formData.name;
                    this.user.avatar = this.formData.avatar;
                    this.$SessionService.setUser(this.user);
                    this.loading = false;
                    this.reloadTemplate();
                }
            );
        },


        async savePassword() {
            this.loadingPassword = true;
            // verifica se a senha possui pelo menos 8 caracteres
            if (this.password.length < 8) {
                this.loadingPassword = false;
                this.passwordMessage = "A senha deve ter no mínimo 8 caracteres";
                this.passwordError = true;
                setTimeout(() => { this.passwordMessage = ""; }, 5000);
                return;
            }

            // verifica se a senha possui alguma sequência de caracteres
            if (this.isSequential(this.password)) {
                this.loadingPassword = false;
                this.passwordMessage = "A senha não pode conter sequências de caracteres";
                this.passwordError = true;
                setTimeout(() => { this.passwordMessage = ""; }, 5000);
                return;
            }

            await this.$ApiService.put(`/settings/users/updateMyPassword`, { "password": this.password }).then(
                (response) => {
                    if (response.error) {
                        this.loadingPassword = false;
                        this.passwordMessage = response.error;
                        setTimeout(() => { this.passwordMessage = ""; }, 5000);
                        return;
                    }

                    this.passwordMessage = "Senha atualizada com sucesso!";
                    this.passwordError = false;
                    setTimeout(() => { this.passwordMessage = ""; }, 5000);
                    this.password = "";
                    this.loadingPassword = false;
                }
            );
        },

        isSequential(str) {
            const alphabet = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
            let count = 1;
            for (let i = 0; i < str.length; i++) {
                if (alphabet.indexOf(str[i]) !== -1 && alphabet.indexOf(str[i]) === alphabet.indexOf(str[i + 1]) - 1) {
                    count++;
                    if (count >= 5) {
                        return true;
                    }
                } else {
                    count = 1;
                }
            }
            return false;
        },

        close() {
            this.formClose();
        },

        tabSelect(tabName) {
            this.currentTab = tabName;
        },
    },

    mounted() {
        this.getData();
    },

}

</script>
